module.exports = __webpack_public_path__ + "img/camera_with_flash.1f0ee041.gif";